export default {
    home_search_for_product: "Căutați produsul dvs.",
conventional_alternative: "Alternativă iluminat convențional",
led_alternative: "Alternativă iluminat LED",
search_filters_filter: "Filtru",
search_submit: "Căutați produsul",
results: "Rezultate",
selected_product: "Produs selectat",
search_input: "Introduceți codul produsului sau descrierea",
what_type_are_you_looking_for: "Ce tip de înlocuitor de produs căutați?",
recommendations_singular: "Recomandări",
recommendations_plural: "Recomandări",
your_product: "Produsul dvs.",
search_filters_reset: "Resetează filtrele",
results_specify: "Există mai mult de 10 rezultate, vă rugăm să restrângeți căutarea",
energy_efficient: "Eficient energetic",
active_filters: "Filtre active",
card_action: "Catalog",
card_show_more: "Arată mai mult",
card_show_less: "Arată mai puțin",
card_alternative_fit: "Cea mai bună alternativă Philips",
card_perfect_fit: "Cel mai potrivit produs Philips",
no_results_found: "Niciun rezultat gasit. Vă rugăm să încercați o altă căutare",
results_no_recommendations: "V-ați blocat? Vă rugăm să contactați reprezentantul de vânzări local pentru a găsi o soluție.",
search_filter_product_type: "Tip produs",
lighting_type: "Tip lampă",
ean: "EAN",
product_code: "Cod produs",
eoc: "EOC",
family: "Familie",
discrete_wattage: "Consum de energie",
wattage: "Consum de energie",
brand: "Marcă",
driver_type: "Tip driver",
number_of_lamps: "Număr lămpi",
length: "Lungime",
color: "Culoare",
base: "Soclu",
local_eoc: "Cod local",
ignitor: "Aprindere",
height: "Înălţime",
width: "Lăţime",
mounting_hole: "Orificiu de montare",
mains_voltage: "Tensiune principală",
thermal_protection: "Protecție termică",
delta_temperature: "Medie de temperatură",
energy_efficiency: "Eficiență energetică",
losses: "Pierderi",
lamp_current: "Tensiune de alimentare a lămpii",
pf_cap: "Dulie",
lumen: "Flux luminous",
energy_saving: "Economie de energie",

};